import {BaseEnvironment} from './types/environment.structure';

export const environment: BaseEnvironment = new BaseEnvironment(true, undefined, undefined, {version: 1}, undefined);
